<script setup>
onMounted(() => {
    console.log('component mounted')
})
</script>
<template>
    <div>
        THIS IS EXAMPLE COMPONENT
    </div>
</template>

